import React from 'react'
import BrandName from './BrandName'
import { ProfilerQuestionID } from '../../config/QuestionEnum'
import { getQuestionConfig } from '../../config/questionsConfig';
import { PROFILER_IMAGES } from '../../Common/constants';
const questionConfig = getQuestionConfig(ProfilerQuestionID.BCM_PLUMBING_PIPE_AND_WATER_TANK_BRANDS);

const BCMBrandPlumbingPipeAndWaterTank = (props) => {
  return (
    <BrandName
      questionId={ProfilerQuestionID.BCM_PLUMBING_PIPE_AND_WATER_TANK_BRANDS}
      title={questionConfig?.question}
      subtitle={questionConfig?.subtitle}
      options={questionConfig?.options || []}
      suggestions={['Astral', 'Supreme', 'Finolex', 'Prince Pipes', 'Sintex']}
      icon={PROFILER_IMAGES.erp_pipes}
      {...props}
    />
  )
}

export default BCMBrandPlumbingPipeAndWaterTank
